<template>
  <div class="gameDetail">
    <HeadBar title="赞助商特邀报名" />
    <div class="gameContent">
      <div class="gameTop">
        <img :src="matchInfoAjax.pictureUrl" :alt="matchInfoAjax.matchName" width="100%" />
        <div class="showDressSize">{{ matchInfoAjax.matchName }}赞助商特邀报名</div>
      </div>
    </div>

    <div class="gameContent mt-15">
      <div>
        <p v-for="(item, index) in projectList" :key="index" @click="goToLinkUrl(index)" class="codeTitle">{{(index + 1
          )
          + '、' + item.projectName}} -- 去报名</p>
      </div>

      <div>
        <!-- <p class="titleProject">您正在使用赞助商邀请码的方式进行报名</p> -->
        <p class="titleProject checkedTitle">{{projectList && projectList[this.index] &&
          projectList[this.index].projectName ? projectList[this.index].projectName : '请选择报名项目' }}</p>
        <van-field class="font30" v-model="code" name="code" label="邀请码" placeholder="请输入邀请码" />
        <div class="codeContent">
          <van-button type="danger" @click="goLink(projectList)" round class="goBaomingBtn1">使用邀请码报名</van-button>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { getQueryString, fetchHttp, formatTime } from "@/util/fn.js";

  import { Toast, Button, Tab, Tabs } from "vant";

  export default {
    name: "gameDetail",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
    },
    data() {
      return {
        active: 0,
        matchInfoAjax: {},
        userId: Cookies.get("USERID"),
        menuList: [],
        matchId: getQueryString("matchId"),
        online: getQueryString("online"),
        index: getQueryString("index"),
        projectList: [],
        code: '',
        ifHasIndex: false
      };
    },
    computed: {
      spliceText(text) {
        return text;
      },
      // dynamicClass(){
      //   if((this.index+1) > 0){
      //     return 'codeTitle'
      //   }else{
      //     return 'codeTitle'
      //   }
      // }
    },
    mounted() {
      let id = getQueryString("matchId");
      if (id) {
        //获取赛事详情
        fetchHttp("marathon/match/getMatchInfo", { id }, "GET").then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.matchName) {
              if (res && res.data && res.data.matchTime) {
                res.data.matchTime = formatTime(res.data.matchTime);
                res.data.endTime = formatTime(res.data.endTime);
                res.data.startTime = formatTime(res.data.startTime);
                this.endTime = res.data.endTime;
                this.matchName = res.data.matchName;
              }
              this.matchInfoAjax = res.data;
              let menuList = res.data && res.data.newsList;
              let renderMenuList = [];
              menuList.forEach((item) => {
                item.newSid ? renderMenuList.push(item) : "";
              });
              this.menuList = renderMenuList;
            } else {
              Toast("没有找到相关赛事");
            }
          }
        });
        //获取项目信息
        fetchHttp("marathon/project/information", { matchId: id }, "GET").then(
          (res) => {
            if (res && res.code === 0) {
              this.projectList = res.data;
            }
          }
        );
      } else {
        Toast("没有找到相关的赛事项目");
      }
    },
    methods: {
      goLink(projectList) {
        
        let item = projectList[this.index];
        if(!item){
          Toast("请选择报名的项目");
          return;
        }
        let reg = /^([a-zA-z]|[0-9]){5,18}$/;
        let baomingHref = '';
        if (reg.test(this.code)) {
          baomingHref = `gameSignUp?matchId=${this.matchId}&matchName=${this.matchName}&projectId=${item.id}&index=${this.index}&online=${this.online}&endTime=${formatTime(this.endTime)}&price=${item.price}&projectCode=${this.code}`;
          //检查登陆
          this.checkLogin(() => {
            if (item.state === 2) {
              window.location.href = baomingHref;
            } else {
              Toast("该比赛不在报名期，去赛事列表看看其他比赛吧！");
              return false;
            }
          });
        } else {
          Toast("请输入正确的邀请码");
          this.code = '';
        }
      },

      goToLinkUrl(index) {
        this.index = index;
        this.ifHasIndex = true;
      },

      checkLogin(callback) {
        //获取基本信息
        fetchHttp(
          "marathon/getUserInfo",
          { id: this.userId },
          "GET",
          "showError"
        ).then((res) => {
          if (res && res.code === 0) {
            if (callback) {
              callback();
            }
          }
        });
      },
    },
  };
</script>
<style scope lang="less">
  .font30 {
    font-size: 20px;
    margin: 30px 0;

    .van-field__label {
      color: red !important;
    }
  }

  .codeTitle {
    width: 100%;
    text-align: center;
    font-size: 20px;
    text-align: left;
    padding: 5px 15px;
    border-bottom: 1px solid #ddd;
    line-height: 30px;
  }

  .goBaomingBtn1 {
    width: 100%;
    text-align: center;
    padding: 0 15px;
  }

  .codeContent {
    padding: 20px;
  }

  .titleProject {
    font-size: 20px;
    padding: 30px 10px 10px;
    line-height: 20px;

  }

  .checkedTitle {
    color: red;
  }

  .showDressSize {
    font-size: 20px;
    padding: 10px 10px 0;
    line-height: 35px;
  }

  .mt-15 {
    padding-top: 5px;
    /* margin-top: -17px; */
  }
</style>